import { EmotionIsAtLeast } from '../../presentation/BottomBar/EmotionSelector/EmotionSelector';
import { Emotions } from './Emotions';
import { IEmotion } from './IEmotion';

export class Emotion implements IEmotion {
	constructor(emotion: IEmotion) {
		this.character = emotion.character;
		this.tooltip = emotion.tooltip;
		this.hexColor = emotion.hexColor;
		this.shieldHueRotateDegrees = emotion.shieldHueRotateDegrees;
		this.keystrokesFancyName = emotion.keystrokesFancyName;
	}

	readonly character: string;
	readonly tooltip: string;
	readonly hexColor: string;
	readonly shieldHueRotateDegrees: number;
	readonly keystrokesFancyName: string;

	IsAtLeast(emotion: IEmotion): boolean {
		return EmotionIsAtLeast(this, emotion);
	}
	
	IsHigherThan(emotion: IEmotion): boolean {
		return Emotions.IndexOf(this) > Emotions.IndexOf(emotion);
	}

	get Index(): number {
		return Emotions.IndexOf(this);
	}

	get Previous(): Emotion {
		if (this.Index === 0) {
			return this;
		}
		else {
			const emotionsBefore = Emotions.Before(this);
			return Emotions.Before(this)[emotionsBefore.length - 1];
		}
	}

	get Next(): Emotion {
		if (this.Index === Emotions.All.length - 1) {
			return this;
		}
		else {
			return Emotions.After(this)[0];
		}
	}
}
